

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePack, ceTogglePack } from '../../../redux/actions/checkout_operations';
import {
  lpPattern, P_SELECT_PACK_1, P_SELECT_PACK_2,
} from '../../../tracking/pattern_detector';
import Faq from './faq';
import lpApp from '../../../app/lp_app';


class OneColumnPack extends Component {
  constructor(props) {
    super(props);
    console.log(props)

    this.onChoose = this.onChoose.bind(this);

    this.state = {
      packs: OneColumnPack.getPacksFeatures(),
      packNames: this.getPackInfo(),
    };
  }

  componentDidUpdate() {
      console.log('UPDATE', this.state)
  }

  onChoose(e) {
    const chosenPack = +(e.target.attributes['data-pack'].value);
    if (chosenPack === 1) {
      this.props.selectOne();
    }
    else this.props.selectTwo();
    this.props.togglePack(true);
  }

  getPackInfo() {
    switch (lpApp.contractMetaId) {
        /*
        * Cse moins de 20 employés
        */
       case 229:
       return [
         {
           h1: 'Élection du CSE de votre société',
           title: 'Élection simplifiée',
           price: `${this.props.first_price}€`,
           fees: 'Procédure pour confirmer l’absence de candidat aux élections'
         }
       ];
    }
  }


  static getPacksFeatures() {
    switch (lpApp.contractMetaId) {
      /* Cse plus de 20 */
      case 229:
        return [
          {
            title: 'Retroplanning ',
            isTitle: false,
            isSpacer: false,
            checks: [true],
          }, {
            title: "Tous vos documents légaux sur-mesure",
            isTitle: false,
            isSpacer: false,
            checks: [true],
          }, {
            title: 'Suivi de votre procédure par un expert',
            isTitle: false,
            isSpacer: false,
            checks: [true],
          }, {
            title: 'Assistance téléphonique',
            isTitle: false,
            isSpacer: false,
            checks: [true],
          },
          {
            title: 'Attention : valable uniquement pour les entreprises de moins de 21 salariés et si aucun candidat ne se déclare sous 30 jours. Si un candidat se déclare, alors nous vous proposerons de souscrire à l\'une des deux autres offres (le prix déjà payé pour cette offre sera déduit)',
            isTitle: false,
            isSpacer: false,
            isWarning: true,
            checks: [true],
          },

        ];
      default:
        return null;
    }
  }

  render() {
    const getContractName = (contractMetaId) => {
      switch (contractMetaId) {
        case 230:
          return "Election du CSE de votre société";
      case 229:
        return "Election du CSE de votre société";
        default:
          break;
      }
    };

    const getPackInfo = (packIndex) => {
      const packList = [];
      this.state.packs.forEach((opt, i) => {
        if (opt.checks[packIndex] === true) {
          let className = '';

          if (opt.isTitle) {
            className = 'is-title';
          } else if (opt.isSpacer) {
            className = 'is-spacer';
          } else if (opt.isWarning) {
            className = 'is-warning'
          }

          const li = (
            <li key={`cemobpck-${i}`} className={className}>
              {!opt.isWarning && (<i className="icn-checkmark" />)}
              {(opt.dynamic)
                ? (
                  <span>
                    {opt.title}
                    {' '}
                    {(packIndex === 0) ? `d'${getContractName(lpApp.contractMetaId)}` : ''}
                    {' '}
                    {(packIndex === 1) ? '+ dossier complet' : ''}
                    {' '}
                  </span>
                )
                : (
                  <span>
                    {opt.title}
                    {' '}
                  </span>
                )}
            </li>
          );
          packList.push(li);
        }
      });

      return packList;
    };

    return (
      <div>
        <section>
          <div className="container">
            <div className="sc-heading">
              <h1 className="sc-title">{this.getPackInfo()[0].h1}</h1>
            </div>
            <div>
              <ul className="pricing-table-x5 pt-x5-2">
                <li className="pt-pack">
                  <div className="pack-head">
                    <h2 className="pack-title">{this.getPackInfo()[0].title}</h2>
                    <span className="pack-stitle">{this.getPackInfo()[0].sub}</span>
                  </div>
                  <div className="pack-pricing">
                    <h4 className="px-pricing">
                      <div className="price-current">
                        <span className="pp-value">{this.getPackInfo()[0].price}</span>
                        <span className="pp-tax">HT</span>
                      </div>
                    </h4>
                    <div className="pp-mention">{(this.getPackInfo()[0].fees) ? this.getPackInfo()[0].fees : 'Sans frais administratifs'}</div>
                  </div>
                  <div className="xcta" href="#" data-pack="1" onClick={this.onChoose}>Choisir ce pack</div>
                  <ul className="pack-features">
                    {getPackInfo(0)}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </section>
          <Faq />
        </div>
    );
  }
}


const mapStateToProps = state => {
    console.log('state lmerge to proips', state)
return {
  first_price: state.checkout_operations.prices.first_price,
  chosen_pack: state.checkout_operations.pack,
  pricing_loading: state.loading_details.pricing,
  promo_percentage: state.checkout_operations.promo_percentage,
  title: state.contract.name,
}};

const mapDispatchToProps = dispatch => ({
  togglePack: (val) => {
    dispatch(ceTogglePack(val));
  },
  selectOne: () => {
    dispatch(ckUpdatePack(0));
    lpPattern.trackInPayment(P_SELECT_PACK_1);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OneColumnPack);



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/oneColumnPack.js